module.exports = __webpack_public_path__ + "svg/fullscreen-open.svg?3e41ff9fc9189ad2b51811b2e6ee5499";